<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title">
            付款账户<span><el-button size="mini"  @click="dialogVisible = true">新增</el-button></span>
        </div>
        <div class="user_content_blcok_line"></div>
        <div class="user_content_block_show">
      <div class="table-layout" v-if="list.length > 0">
        <el-row>
          <el-col :span="6" class="table-cell-title">开户行</el-col>
          <el-col :span="3" class="table-cell-title">开户人姓名</el-col>
          <el-col :span="9" class="table-cell-title">卡号</el-col>
          <el-col :span="6" class="table-cell-title">操作</el-col>
        </el-row>
        <el-row v-for="(v,k) in list" :key="k">
          <el-col :span="6" class="table-cell">{{v.bankId}}</el-col>
          <el-col :span="3" class="table-cell">{{v.name}}</el-col>
          <el-col :span="9" class="table-cell">{{v.account}}</el-col>
          <el-col :span="6" class="table-cell">
                            <el-button v-show="v.isDefault == true" type="success" disabled size="mini">默认账号</el-button>
                            <el-button v-show="v.isDefault == false" type="primary" @click="set_default(v)" size="mini">设置默认</el-button>
                            <el-button @click="get_address_info(v.id,v)" size="mini">编辑</el-button>
                            <el-button type="danger" @click="del(v.id)" size="mini">删除</el-button>
          </el-col>
        </el-row>
      </div>


            
           <div class="home_empty_list" v-else>
            <i class="font iconfont">&#xe600;</i>暂无付款账户！
        </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" :title="edit_id>0?'编辑付款账户':'新增付款账户'" @close="close_dialog" width="40%" :close-on-click-modal="false">
            <div class="home_form_main">
                <el-form  label-width="150px" ref="info" :model="info" size="small">
<el-form-item label="户名" prop="name" :rules="[{required:true,message:'户名不能为空',trigger: 'blur' }]"><el-input placeholder="请输入户名" v-model="info.name"></el-input></el-form-item>
<el-form-item label="账号" prop="account" :rules="[{required:true,message:'银行账不能为空',trigger: 'blur' },{min: 16, max: 23, message: '请输入16至19位银行卡账号', trigger: 'blur'}]"><el-input placeholder="请输入账号" v-model="info.account" @on-change="refoundNumber" @change="refoundNumber"></el-input></el-form-item>
<el-form-item label="银行" prop="bankId" :rules="[{required:true,message:'开户行不能为空',trigger: 'blur' }]"><el-input placeholder="请输入开户行" v-model="info.bankId"></el-input></el-form-item>
<el-form-item label="是否默认">
    <el-radio-group v-model="info.isDefault" size="mini">
      <el-radio-button label="true" >是</el-radio-button>
      <el-radio-button label="false">否</el-radio-button>
    </el-radio-group>
</el-form-item>


                </el-form>


            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="restForm('info')">取 消</el-button>
                <el-button type="danger" @click="submitForm('info')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import {bankCardAttribution} from '@/utils/bankcard.js';
  const defaultInfo = {
    name:null,
    account:null,
    bankId:'',
    isDefault:true,
    status:3,
  };
export default {
    components: {
        bankCardAttribution
    },
    props: {},
    data() {
      return {
          dialogVisible:false,
          edit_id:0,
          list:[],
          info: Object.assign({}, defaultInfo),
          preStoreUtils: {
              cardNumber:null,
              openingBank:null
          },
      };
    },
    watch: {
            //此步骤是为了更清楚的格式化银行卡号，每4位一个空格
            'info.account'(val) {
                this.$nextTick(() => {
                    this.info.account = val
                        .replace(/\D/g, '')
                        .replace(/....(?!$)/g, '$& ');
                });
            }
    },
    computed: {},
    methods: {
      restForm:function(){
          this.$refs['info'].resetFields()
          this.dialogVisible = false;
      },
        submitForm:function(e){
            let _this = this;
            // 验证表单
            this.$refs[e].validate(function(res){
                
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.createBankAccount;
                    if(_this.edit_id>0){
                        url = _this.$api.updateBankAccount+_this.edit_id;     
                        // Http 请求
                        _this.$put(url,_this.info).then(function(res){
                            if(res.code == 200){
                                _this.$message.success("编辑成功");
                                _this.$refs['info'].resetFields()
                                _this.dialogVisible = false;
                                _this.getBankAccount();
                            }else{
                                _this.$message.error(res.message);
                            }
                        });
                    }else {
                    url = _this.$api.createBankAccount; 
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("添加成功");
                            _this.$refs['info'].resetFields()
                            _this.dialogVisible = false;
                            _this.getBankAccount();
                        }else{
                            _this.$message.error(res.message);
                        }
                    });
                    }

                }
            });
        },
            // 此步骤是银行卡号匹配银行类型的方法
            refoundNumber() {
                let number = this.info.account;
                let num = number.replace(/\s+/g, '');
                let obj = bankCardAttribution(num);
                if (obj === 'error') {
                    this.$Message.error('请输入正确的银行卡号！');
                } else {
                    this.info.bankId = obj.bankName;
                }
            },
        
        getBankAccount:function(){
            this.$get(this.$api.getBankAccount).then(res=>{
                this.list = res.data;
                this.edit_id = res.data[0].id;
            });
        },
        //当前ID信息
        get_address_info:function(id){
            this.edit_id = id;
            this.dialogVisible = true;
            this.$get(this.$api.getBankAccountById+id).then(res=>{
                this.info = res.data;
                this.info.name = res.data.name;
                this.info.account = res.data.account;
                //this.info.status = res.data.status==3?false:true;
            });
        },
    
        
        set_default:function(v){
            this.info.name = v.name,
            this.info.account = v.account,
            this.info.id = v.id,
            this.$put(this.$api.setDefaultBankAccount + this.info.id,{id:this.info.id,status:3,isDefault:true,name:this.info.name,account:this.info.account}).then(res=>{
                if(res.code==200){
                this.$message.success('设置默认账户成功');
                this.getBankAccount();
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // 删除处理
        del:function(id){
        this.$confirm('是否要删除付款账户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let _this = this;
            this.$delete(this.$api.deleteBankAccount +id).then(function(res){
                if(res.code == 200){
                    _this.getBankAccount();
                    return _this.$message.success("删除成功");
                }else{
                    return _this.$message.error(res.message);
                }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
          this.getBankAccount();
        });
        },

        close_dialog:function(){
            this.edit_id = 0;
        }
    },
    created() {
        this.getBankAccount();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.user_address_list{
    padding-top: 10px;
    ul li{
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        dl{
            float: left;
            display: block;
            width: 650px;
            dt{
                margin-right: 20px;
                font-size: 14px;
                line-height: 30px;
            }
            dd{
                line-height: 20px;
                width: 190px;
                width: 500px;
                float: left;
            }
            dd.address_info{
                color:#999;
                float: left;
                width:100%;
                width: 500px;
            }
        }
        .address_handle{
            color:#666;
            float:right;
            line-height: 40px;
            span{
                margin: 0 10px; 
                i{
                    margin-right: 10px;
                }
                
            }
            span:hover{
                color:#F56C6C;
            }
            span.red{
                color:#F56C6C;
            }
        }
    }

}
    select{
        height: 32px !important;
        line-height: 32px !important;
        padding: 0 !important;
    }
   .home_form_main .el-input, .el-textarea {
        max-width: 250px;
        height: 32px;
        line-height: 32px;
    }
   .home_form_main .el-input--small .el-input__inner {
        max-width: 250px;
        height: 32px;
        line-height: 32px;
        }
.el-cascader {
    display: inherit;
    position: relative;
    font-size: 14px;
    line-height: 32px;
    height: 32px;
    max-width: 250px;
}   

.table-layout {
    margin-top: 20px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
  }

  .table-cell {
    height: 48px;
    line-height: 48px;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    font-size: 14px;
    color: #606266;
    text-align: center;
    overflow: hidden;
  }
  .table-cell p{
    line-height: 35px;
  }
  .table-cell-title {
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    height: 48px;
    line-height: 48px;
    background: #f5f7fa;
    text-align: center;
    font-size: 14px;
    color: #909399;
  }

</style>